import { useModuleAssessmentStore } from './ModuleAssessment.store';
import { UserAssesmentDialog } from 'features/training/components';

const AnswerModuleAssessment = () => {
  const { setModuleIdToAnswer, moduleIdToAnswer, setModuleName } = useModuleAssessmentStore();
  const onClose = () => {
    setModuleIdToAnswer('');
    setModuleName('');
  };

  if (!Boolean(moduleIdToAnswer)) return null;
  return (
    <UserAssesmentDialog
      moduleAssessmentId={moduleIdToAnswer} // This prop tells dialog its a module based assessment
      open={Boolean(moduleIdToAnswer)}
      handleUserAssesment={onClose}
    />
  );
};

export default AnswerModuleAssessment;
